let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("0X1i0")]).then(() => parcelRequire('f6GYX'));